import React from 'react';

const IconCurvedArrowRight = ({ size = 36, onClick }) => {
    return (
        <div
            className="icon-arrow-right"
            style={{ fontSize: size }}
            onClick={onClick} // Add onClick handler
        >
            <svg xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 25 25" style={{ height:"25px"}}>
                <path style={{fill:"white"}} d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z" data-name="Right"/>
            </svg>
        </div>
    );
};

export default IconCurvedArrowRight;
